import { render, staticRenderFns } from "./BRIGList.vue?vue&type=template&id=6887a61e&scoped=true&"
import script from "./BRIGList.vue?vue&type=script&lang=js&"
export * from "./BRIGList.vue?vue&type=script&lang=js&"
import style0 from "./BRIGList.vue?vue&type=style&index=0&id=6887a61e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887a61e",
  null
  
)

export default component.exports